// API configuration — override via .env.local for dev proxying
export const BASE_URL =
  (import.meta.env['VITE_API_URL'] as string | undefined) ??
  'https://api.gardenbagsbrisbane.com.au/app/';

export const CHAT_SERVER =
  (import.meta.env['VITE_CHAT_SERVER'] as string | undefined) ??
  'https://api.gardenbagsbrisbane.com.au:8080';

export const TOKEN_KEY = '26F2IkCfPo2u';

// Google Maps switches the Run map on, so it has no default. SST passes '' on
// personal stages, which `??` would let through, so empty counts as missing.
export const GOOGLE_MAPS_API_KEY = emptyAsUndefined(
  import.meta.env['VITE_GOOGLE_MAPS_API_KEY'] as string | undefined,
);

export const GOOGLE_MAPS_MAP_ID = emptyAsUndefined(
  import.meta.env['VITE_GOOGLE_MAPS_MAP_ID'] as string | undefined,
);

function emptyAsUndefined(value: string | undefined): string | undefined {
  return value === '' ? undefined : value;
}
